export const MARKETING_WEBSITE_URL = "https://www.simplebooth.com"
export const PLATFORM_HOME_URL = "https://www.simplebooth.com"
export const HELP_CENTER_URL = "https://help.simplebooth.com"
export const SUPPORT_EMAIL = "support@simplebooth.com"